import React from 'react';
import styles from '../css/modules/ContentPage.module.css';
import SEO from '../components/SEO';
import { FIRMA } from '../data/firma';

export default function ZaburzeniaNiemowlat() {
  return (
    <div className={styles.page}>
      <SEO
        title="Zaburzenia integracji sensorycznej u niemowląt Olsztyn | Sensorini"
        description="Jak rozpoznać zaburzenia SI u niemowląt. Terapia sensoryczna dla niemowląt w Olsztynie. Objawy i wczesna interwencja w Sensorini Olsztyn."
        pathname="/zaburzenia-niemowlat/"
        type="article"
      />

      <header className={styles.hero}>
        <span className={`${styles.blob} ${styles.blobA}`} aria-hidden="true" />
        <span className={`${styles.blob} ${styles.blobB}`} aria-hidden="true" />
        <div className={styles.heroInner}>
          <span className={styles.eyebrow}>Rozwój niemowląt • Olsztyn</span>
          <h1 className={styles.h1}>
            Zaburzenia integracji sensorycznej u niemowląt
          </h1>
          <p className={styles.lead}>
            Zaburzenia integracji sensorycznej u niemowląt można rozpoznać już w pierwszych miesiącach życia - w Sensorini w Olsztynie pomożemy Ci je odczytać i odpowiednio wesprzeć rozwój dziecka.
          </p>
        </div>
      </header>

      <div className={styles.wrap}>
        <section className={styles.section}>
          <img
            className={styles.figure}
            src="/image/zaburzenia-niemowlat.webp"
            alt="Zaburzenia u niemowląt Olsztyn"
            loading="lazy"
          />
          <p>
            Integracja sensoryczna to podstawa dla prawidłowego rozwoju każdego dziecka. Już w pierwszych miesiącach życia mogą pojawić się objawy zaburzeń które wymagają uwagi i odpowiednich wskazówek. Jeśli mieszkasz w Olsztynie lub okolicach i coś cię niepokoi nasza terapia sensoryczna Olsztyn jest właśnie dla Ciebie.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Objawy zaburzeń SI u niemowląt</h2>
          <p>
            Wczesne symptomy mogą być różne i często są mylone ze zwykłym niemowlęcym niepokojem. Mogą obejmować nadmierną płaczliwość, ogromne problemy ze ssaniem piersi lub butelki, bardzo niespokojny sen. Czasem niemowlę unika kontaktu z najbliższymi nie lubi być przytulane albo wręcz przeciwnie ciągle tego potrzebuje. U dzieci rocznych i dwuletnich często pojawia się nietolerancja zabiegów pielęgnacyjnych jak mycie włosów czy obcinanie paznokci, bardzo ograniczony repertuar żywieniowy czy ogromne trudności w zasypianiu. To mogą być sygnały że potrzebna jest terapia sensoryczna dla niemowlat Olsztyn.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Diagnoza integracji sensorycznej w Olsztynie</h2>
          <p>
            Pełną i profesjonalną diagnozę przetwarzania sensorycznego wykonuje się u dzieci które ukończyły 4 rok życia. U młodszych dzieci, tak do 3 lat, mówimy raczej o rozpoznaniu zaburzeń samoregulacji które są związane z przetwarzaniem bodźców. Celem takiej konsultacji i wczesnej interwencji w Olsztynie jest przede wszystkim poprawa funkcjonowania dziecka ale też wsparcie całej rodziny w codziennych wyzwaniach.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Jak rozwijają się zmysły?</h2>
          <p>
            Proces integracji sensorycznej zaczyna się bardzo wcześnie bo już około 9-11 tygodnia życia płodowego. Jako pierwszy rozwija się układ dotykowy, zaraz po nim przedsionkowy (odpowiedzialny za równowagę) i proprioceptywny (czucie głębokie). U noworodka zmysły słuchu wzroku smaku i węchu są jeszcze niedojrzałe co w naturalny sposób chroni go przed nadmiarem bodźców z zewnątrz.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Czynniki ryzyka - co może mieć wpływ?</h2>
          <p>
            Predyspozycje do zaburzeń SI mogą być genetyczne ale często są też związane z przebiegiem ciąży i porodu. Na przykład niska lub bardzo wysoka masa urodzeniowa niska ocena w skali APGAR przebyte infekcje czy odklejenie łożyska. Trzeba jednak pamiętać że nie każde dziecko z grupy ryzyka na pewno rozwinie zaburzenia integracji sensorycznej.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Na co zwrócić szczególną uwagę jako rodzic?</h2>
          <ul className={styles.list}>
            <li>przewlekłe problemy ze snem i zasypianiem, ogromne trudności z wyciszeniem się</li>
            <li>problemy z karmieniem ssaniem i połykaniem a później z rozszerzaniem diety</li>
            <li>histeryczny płacz przy kąpieli czesaniu myciu czy obcinaniu paznokci</li>
            <li>wyraźna niechęć do przytulania, unikanie kontaktu wzrokowego z rodzicem</li>
            <li>nadwrażliwość na ból lub wręcz przeciwnie brak odczuwania bólu</li>
            <li>częste gryzienie szczypanie siebie lub innych uderzanie głową w meble</li>
            <li>nadwrażliwość na światło, nagłe lub głośne dźwięki</li>
            <li>inne zachowania które są niezrozumiałe lub bardzo niepokojące dla rodziców</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Kiedy potrzebna jest terapia sensoryczna?</h2>
          <p>
            Jeśli obserwujesz u swojego maluszka niepokojące objawy nie czekaj. Warto skonsultować się z doświadczonym specjalistą. Nasza terapia sensoryczna dla niemowlat w Olsztynie to miejsce gdzie uzyskasz profesjonalne wsparcie. Taka wczesna interwencja Olsztyn ma ogromne znaczenie. Konsultacje z terapeutą SI w moim gabinecie w Olsztynie są możliwe już od 6 miesiąca życia dziecka. Zapraszam serdecznie do kontaktu i umówienia wizyty.
          </p>
          <p className={styles.callout}>Jeżeli jesteś z Olsztyna zapraszam do mojego gabinetu!</p>
        </section>

        <section className={styles.section}>
          <h2>Bibliografia</h2>
          <p className={styles.muted}>Źródła wykorzystane przy opracowaniu treści:</p>
          <ul className={styles.chips}>
            <li>Red. zbiorowa; <em>Klasyfikacja diagnostyczna DC: 0-3R</em>, Fundament, 2007</li>
            <li>A.J. Ayres; <em>Dziecko a integracja sensoryczna</em>, Harmonia Universalis, 2018</li>
            <li>A. Charęzińska, J. Szulc; <em>Sensoryczne niemowlę</em>, Mamania, 2019</li>
            <li>M. Szczerpa-Fabian i in.; <em>The Prenatal and Perinatal Risk Variables...</em>, 2018</li>
            <li>N. Kołat; <em>Zaburzenia przetwarzania sensorycznego u dzieci</em>, Nowa Pediatria, 2014</li>
            <li>Standardy opieki nad dzieckiem urodzonym przedwcześnie, PTN/PTP, 2018</li>
            <li>P. Zawitkowski; <em>Mamo tato co ty na to?</em>, 2016</li>
          </ul>
        </section>
      </div>

      <section className={styles.ctaBand}>
        <div className={styles.ctaInner}>
          <h2>Masz wątpliwości co do rozwoju niemowlaka?</h2>
          <p>Umów konsultację lub diagnozę integracji sensorycznej w Olsztynie.</p>
          <div className={styles.ctaBtns}>
            <a href="/diagnoza-sensoryczna-olsztyn/" className={styles.btnPrimary} data-cta="booking" data-cta-location="final">Umów diagnozę</a>
            <a href={`tel:${FIRMA.telefonE164}`} className={styles.btnGhost}>Zadzwoń: {FIRMA.telefon}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
